/*
 * Shopper Approved's group2.0 widget only populates the first `.star_container`
 * in DOM order for a given parent ID (it dedupes fetches per ID and writes the
 * result via document.querySelector, which returns a single element). Since
 * this theme intentionally reuses the same parent ID across many product cards
 * in a category, every card after the first stays blank. This script copies
 * the widget's rendered result from a populated container into the other
 * empty containers sharing the same ID. It never modifies the vendor script
 * and never fabricates content for an ID that hasn't been populated yet.
 */
(function () {
  var CONTAINER_SELECTOR = '.star_container';
  var POPULATED_SELECTOR = '.group-stars';

  function getShopperApprovedId(container) {
    for (var i = 0; i < container.classList.length; i++) {
      var className = container.classList[i];
      if (className !== 'star_container') {
        return className;
      }
    }
    return null;
  }

  function stripIds(node) {
    if (node.nodeType !== 1) return;
    node.removeAttribute('id');
    var withIds = node.querySelectorAll('[id]');
    for (var i = 0; i < withIds.length; i++) {
      withIds[i].removeAttribute('id');
    }
  }

  function reconcile() {
    var containers = document.querySelectorAll(CONTAINER_SELECTOR);
    var groups = new Map();

    for (var i = 0; i < containers.length; i++) {
      var container = containers[i];
      var id = getShopperApprovedId(container);
      if (!id) continue;

      if (!groups.has(id)) groups.set(id, []);
      groups.get(id).push(container);
    }

    groups.forEach(function (group) {
      if (group.length < 2) return;

      var source = null;
      var empties = [];

      for (var i = 0; i < group.length; i++) {
        var populated = group[i].querySelector(POPULATED_SELECTOR);
        if (populated && !source) {
          source = populated;
        } else if (!populated) {
          empties.push(group[i]);
        }
      }

      if (!source || empties.length === 0) return;

      for (var j = 0; j < empties.length; j++) {
        var clone = source.cloneNode(true);
        stripIds(clone);
        empties[j].appendChild(clone);
        empties[j].setAttribute('data-sa-fanout', 'true');
      }
    });
  }

  var reconcileScheduled = false;
  function scheduleReconcile() {
    if (reconcileScheduled) return;
    reconcileScheduled = true;
    requestAnimationFrame(function () {
      reconcileScheduled = false;
      reconcile();
    });
  }

  var observer = new MutationObserver(scheduleReconcile);
  observer.observe(document.body, { childList: true, subtree: true });

  scheduleReconcile();
})();
